export default "__VITE_ASSET__lKi2ebg0__"